import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { JSON_CONTENT_TYPE } from "../../config/api";
import { LoginParam, LoginResult } from "./types";
import setAuthToken from "../../utils/setAuthToken";
import * as api from "./api";

export const getUser = createAsyncThunk("auth/getUser", async () => {
  const result = await api.getUser();

  return result;
});

export const login = createAsyncThunk(
  "auth/login",
  async ({ username, password }: LoginParam) => {
    const url = process.env.REACT_APP_AUTH_SERVICE ?? "";
    const { data } = await axios.post(
      url,
      {
        username,
        password,
      },
      JSON_CONTENT_TYPE
    );

    const { status, message } = data;
    const { token, refresh_token: refreshToken, channel_token: channelToken } = data.data;

    let loginResult: LoginResult;

    if (status === 1) {
      setAuthToken({ token, refreshToken, channelToken });

      const { user, navigations, routes } = await api.getSession();

      loginResult = {
        refreshToken: refreshToken,
        result: true,
        token: token,
        user: user,
        error: "",
        message: "",
        navigations,
        routes,
      };
    } else {
      loginResult = {
        result: false,
        token: "",
        refreshToken: "",
        user: null,
        error: message,
        message: message,
      };
    }

    return loginResult;
  }
);

export const refreshAuth = createAsyncThunk(
  "auth/refresh",
  async (token: string) => {
    const session = await api.getSession();

    return {
      user: session?.user,
      token: token,
      navigations: session?.navigations,
      routes: session?.routes,
    };
  }
);
